import React from 'react';
import _findIndex from 'lodash/findIndex';
import PureSelectionList from './components/PureSelectionList';

class SelectionList extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedItems: [...props.value],
    };
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.value.length !== this.props.value.length
      || prevProps.value.filter((el, index) => el.value !== this.props.value[index].value).length > 0
    ) {
      this.setSelectedItems(this.props.value);
    }
  }

  setSelectedItems = (items) => { this.setState({ selectedItems: [...items] }); }

  isItemChecked = item => (
    this.state.selectedItems.some(selectedItem => selectedItem.value === (item.id || item.value)));

  toggleChecked = (element) => {
    const { selectedItems } = this.state;
    const { multi, onItemSelected } = this.props;
    let elements = selectedItems;

    if (multi) {
      const index = _findIndex(
        selectedItems,
        item => (item.value === element.id),
      );

      if (index !== -1) {
        elements.splice(index, 1);
      } else {
        elements.push({ name: element.name, value: element.id });
      }
    } else {
      elements = [{ name: element.name, value: element.id }];
    }

    this.setState(
      {
        selectedItems: elements,
      }, () => {
        const { selectedItems: changedSelectedItems } = this.state;
        onItemSelected(
          changedSelectedItems.map(item => ({
            name: item.name,
            value: item.value,
          })),
        );
      },
    );
  };

  render() {
    const { items, selectEvent, highlight, onHoverElement, wrap } = this.props;
    const groups = items.map(group => ({
      id: group.group_id,
      name: group.group_label,
      items: group.subItems.map(item => ({
        checked: this.isItemChecked(item),
        name: item.name,
        id: item.value,
        rightButton: item.rightButton,
        caption: item.caption,
      })),
    }));

    return (
      <PureSelectionList
        groups={groups}
        onItemSelected={this.toggleChecked}
        selectEvent={selectEvent}
        highlight={highlight}
        onHoverElement={onHoverElement}
        wrap={wrap}
      />
    );
  }
}

SelectionList.defaultProps = {
  multi: false,
  value: [],
  selectEvent: 'onClick',
  highlight: null,
  onHoverElement: () => {},
  wrap: false,
};

export default SelectionList;
